export enum PermissionEnum {
	SUPER_ADMIN = "super-admin",
	GUEST = "guest",
	ESUS_VIEW_INDICATORS = "esus-view-indicators",
	ESUS_VIEW_CITIZEN_MANAGEMENT = "esus-view-citizen-management",
	ESUS_VIEW_PROFESSIONAL_MANAGEMENT = "esus-view-professional-management",
	ESUS_VIEW_REPORTS = "esus-view-reports",
	ESUS_CONFIG_DATA_IMPORT = "esus-config-data-import",
	ESUS_VIEW_STATE_REPORTS = "esus-view-state-reports",
	ESUS_STATE_PROFESSIONAL_MANAGEMENT = "esus-state-professional-management",
	SINTEGRADA_PROFESSIONAL_MANAGEMENT = "sintegrada-professional-management",
	SINTEGRADA_VIEW_REPORTS = "sintegrada-view-reports",
}
